// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605180202/js/" + chunkId + "." + {"44":"4a69e54a","225":"a927b161","481":"fa21182a","486":"9d7900a5","770":"420588f6"}[chunkId] + ".0.8869506157834635.chunk.js";
};